import { render, staticRenderFns } from "./TransferenciasPropiasTable.vue?vue&type=template&id=e6535c8e&scoped=true"
import script from "./TransferenciasPropiasTable.vue?vue&type=script&lang=ts"
export * from "./TransferenciasPropiasTable.vue?vue&type=script&lang=ts"
import style0 from "./TransferenciasPropiasTable.vue?vue&type=style&index=0&id=e6535c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6535c8e",
  null
  
)

export default component.exports